import React from 'react';
import PropTypes from 'prop-types';
import RadioButton, {RadioButton2} from './RadioButton';

import './RadioGroup.css';

class RadioGroup extends React.Component {

  static propTypes = {
    value: PropTypes.any,
    name: PropTypes.string,
    options: PropTypes.array,
    onChange: PropTypes.func
  }

  render() {
    const {
      value,
      name,
      options,
      onChange
    } = this.props;

    return (
      <div name="RadioGroup">
        <label className="name">{name}</label>
        {options.map((o, i) =>
          <RadioButton
            key={i}
            value={o.value}
            label={o.label}
            checked={o.value === value}
            onChange={onChange} />
        )}
      </div>
    );
  }

}

export const RadioGroup2 = (props: RadioGroup2Props) => {
  const { title, value, name, options, onChange } = props;
  return (
    <div name="RadioGroup">
      <label className="name">{title}</label>
      {options.map((o, i) => (
        <RadioButton2
          key={i}
          name={name}
          value={o.value}
          label={o.label}
          checked={o.value === value}
          onChange={onChange}
        />
      ))}
    </div>
  );
};

export default RadioGroup;
